import {createSelector} from "@reduxjs/toolkit";

const baseState = state => state.video.like;

export const likeVideoErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: !!state.error,
        error: state.error
    }
});